import * as types from './mutation-types'

export const setFullInfo = ({ commit }, payload) => {
    commit(types.SET_FULL_INFO, payload)
}

export const mergeInfo = ({ commit }, payload) => {
    commit(types.MERGE_INFO, payload)
}

export const setCurrent = ({ commit }, payload) => {
    commit(types.SET_CURRENT, payload)
}

export default {
    setFullInfo,
    mergeInfo,
    setCurrent
}
